import { FormProvider, useForm, useWatch } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-toastify";
import { HiQuestionMarkCircle } from "react-icons/hi";
import {
  useCreateKRAMutation,
  useGetAllJobTitleQuery,
  useGetAppraisalObjectivesQuery,
  useGetHrDepartmentsQuery,
  useGetJobRoleQuery,
  useGetListKRAQuery,
  useGetRatingsSelectQuery,
  useGetSingleKeyResultAreaQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  CheckBox,
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../../Components/Forms/InputTemplate";
import {
  appraisalPeriod,
  crossReviewType,
  currencies,
  MeasurementType,
} from "./data";
import { useEffect, useMemo, useState } from "react";
import { DEFINED_PERMISSIONS } from "../../../../../../utils/const";
import { FaMinus, FaPlus } from "react-icons/fa";

export const ObjectiveModal3 = ({ setIsOpen, isOpen, onValidate }) => {

  const [onCreate, { isLoading }] = useCreateKRAMutation();
  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      is360Applicable: false,
      noneCore: false,
      allKras: []
    },
  });
  const {
    handleSubmit,
    formState: { isValid },
    control, setValue, getValues, trigger
  } = formMethods;
  const [index, setIndex] = useState(0);


  const watchDepartment = useWatch({ control, name: `allKras[${index}].departmentId` });
  const { data: departments } = useGetHrDepartmentsQuery();
  const { data: objectives } = useGetAppraisalObjectivesQuery({
    ApprovalStatus: 0,
    departmentId: watchDepartment,
    PageSize: 1000,
    PageNumber: 1,
  });
  const { data: ratings } = useGetRatingsSelectQuery({
    ApprovalStatus: 0,
  });
  const { data: jobRole } = useGetJobRoleQuery({
    ApprovalStatus: 0,
    departmentId: watchDepartment,
    PageSize: 1000,
    PageNumber: 1,
  });
  const { data: keyResultArea } = useGetListKRAQuery({
    ApprovalStatus: 0,
  });
  const is360Applicable = useWatch({ control, name: `allKras[${index}].is360Applicable` });
  console.log('is 360 applicable', is360Applicable)
  const includePeerReview = useWatch({ control, name: `allKras[${index}].includePeerReview` });
  const includeUpwardReview = useWatch({
    control,
    name: `allKras[${index}].includeUpwardReview`,
  });
  const includeCrossReview = useWatch({ control, name: `allKras[${index}].includeCrossReview` });
  const watchMeasurementType = useWatch({
    control,
    name: `allKras[${index}].measurementType`,
  });
  const jobRoleId = useWatch({
    control, name: `allKras[${index}].jobRoleId`
  });
  const jobTitles = useGetAllJobTitleQuery({
    PageSize: 9999, PageNumber: 1,
    ApprovalStatus: 0, JobRoleId: jobRoleId
  })
  const watchRateId = useWatch({ control, name: `allKras[${index}].rateId` });
  const id = useWatch({ control, name: `allKras[${index}].KRA` });

  const { data: populateKRA } = useGetSingleKeyResultAreaQuery(id, {
    skip: !id || id === 0 || id === "0", // Skip query if no valid ID
  });
  useEffect(() => {
    if (watchMeasurementType) {
      const measurementType = MeasurementType.find(
        (type) => type.id === parseInt(watchMeasurementType)
      );
      if (measurementType?.name === "Yes/No") {
        // formMethods.setValue("targetValue", "yesNo");
        formMethods.setValue(`allKras[${index}].targetValue`, 1);
      } else {
        // Clear targetValue for other measurement types to allow user input
        if (measurementType?.name !== "Yes/No") {
          formMethods.setValue(`allKras[${index}].targetValue`, "");
        }
      }
    }
  }, [watchMeasurementType, formMethods, index]);

  // When 360° is not applicable, clear all its child fields
  useEffect(() => {
    if (!is360Applicable) {
      formMethods.setValue(`allKras[${index}].includePeerReview`, false);
      formMethods.setValue(`allKras[${index}].peerReviewAffectsScore`, false);
      formMethods.setValue(`allKras[${index}].includeUpwardReview`, false);
      formMethods.setValue(`allKras[${index}].upwardReviewAffectsScore`, false);
      formMethods.setValue(`allKras[${index}].includeCrossReview`, false);
      formMethods.setValue(`allKras[${index}].crossReviewType`, 0);
      formMethods.setValue(`allKras[${index}].crossReviewAffectsScore`, false);
    }
  }, [is360Applicable, formMethods, index]);

  // Update target value when rating is selected (for Rating measurement type)
  useEffect(() => {
    if (
      parseInt(watchMeasurementType) === 4 &&
      watchRateId &&
      parseInt(watchRateId) > 0
    ) {
      // Find the selected rating
      const selectedRating = ratings?.data?.find(
        (rating) => rating.id === parseInt(watchRateId)
      );

      if (selectedRating && selectedRating.scaleLevels) {
        // Find the highest scaleNumber from the scaleLevels
        const highestScale = Math.max(
          ...selectedRating.scaleLevels.map((scale) => scale.scaleNumber)
        );

        // Set the target value to the highest scale number
        formMethods.setValue(`allKras[${index}].targetValue`, highestScale);

      }
    }
  }, [watchMeasurementType, watchRateId, ratings, formMethods, index]);
  const [isNew, setIsNew] = useState(true);


  // Populate form fields when KRA is selected

  // useEffect(() => {
  //   if (populateKRA?.responseObject && ratings?.data && currencies && isNew) {
  //     const data = populateKRA.responseObject;
  //     // Use setTimeout to ensure the form updates properly
  //     setTimeout(() => {
  //       // Don't reset the form completely - just update individual fields
  //       // This preserves the selected KRA dropdown value

  //       // Populate form fields with KRA data
  //       formMethods.setValue(`allKras[${index}].title`, data.title || "");
  //       formMethods.setValue(`allKras[${index}].objectiveId`, data.objectiveId || 0);
  //       formMethods.setValue(`allKras[${index}].description`, data.description || "");
  //       formMethods.setValue(`allKras[${index}].isFloatable`, data.isFloatable || false);
  //       formMethods.setValue(`allKras[${index}].threshold`, data.threshold || 0);
  //       // formMethods.setValue("isAutoGenerated", data.isAutoGenerated || false);
  //       formMethods.setValue(
  //         "autoGeneratedSource",
  //         data.autoGeneratedSource || ""
  //       );
  //       formMethods.setValue(`allKras[${index}].targetValue`, data.targetValue || 0);
  //       formMethods.setValue(`allKras[${index}].measurementType`, data.measurementType || 0);

  //       // Handle currency type - match exact value from currencies array
  //       if (data.currencyType) {
  //         formMethods.setValue(`allKras[${index}].currencyType`, data.currencyType, {
  //           shouldValidate: true,
  //         });
  //         console.log("Setting currencyType to:", data.currencyType);
  //       } else {
  //         formMethods.setValue(`allKras[${index}].currencyType`, "", { shouldValidate: true });
  //       }

  //       // Handle ratings - ensure it's a valid rateId
  //       if (data.rateId && data.rateId > 0) {
  //         formMethods.setValue(`allKras[${index}].rateId`, data.rateId, { shouldValidate: true });
  //         console.log("Setting rateId to:", data.rateId);
  //       } else {
  //         formMethods.setValue(`allKras[${index}].rateId`, 0, { shouldValidate: true });
  //       }

  //       formMethods.setValue(`allKras[${index}].appraisalPeriod`, data.appraisalPeriod || 0);

  //       // Handle jobRoleId - check if it exists and is valid
  //       if (data.jobRoleId && data.jobRoleId !== null) {
  //         formMethods.setValue(`allKras[${index}].jobRoleId`, data.jobRoleId);
  //         console.log("Set jobRoleId to:", data.jobRoleId);
  //       } else {
  //         formMethods.setValue(`allKras[${index}].jobRoleId`, 0);
  //         console.log("jobRoleId is null, setting to 0");
  //       }

  //       // Format dates for input fields
  //       if (
  //         data.periodStartDate &&
  //         data.periodStartDate !== "0001-01-01T00:00:00"
  //       ) {
  //         const startDate = new Date(data.periodStartDate)
  //           .toISOString()
  //           .split("T")[0];
  //         formMethods.setValue(`allKras[${index}].periodStartDate`, startDate);
  //         console.log("Set periodStartDate to:", startDate);
  //       } else {
  //         // Clear the field if no valid date
  //         formMethods.setValue(`allKras[${index}].periodStartDate`, "");
  //       }

  //       if (
  //         data.periodEndDate &&
  //         data.periodEndDate !== "0001-01-01T00:00:00"
  //       ) {
  //         const endDate = new Date(data.periodEndDate)
  //           .toISOString()
  //           .split("T")[0];
  //         formMethods.setValue(`allKras[${index}].periodEndDate`, endDate);
  //         console.log("Set periodEndDate to:", endDate);
  //       } else {
  //         // Clear the field if no valid date
  //         formMethods.setValue(`allKras[${index}].periodEndDate`, "");
  //         console.log(
  //           "Period end date not set - clearing field. Value:",
  //           data.periodEndDate
  //         );
  //       }

  //       // SLA fields
  //       formMethods.setValue(`allKras[${index}].slA_StartDuration`, data.slaStartDuration || 0);
  //       formMethods.setValue(`allKras[${index}].slA_ReviewDuration`, data.slaReviewDuration || 0);
  //       formMethods.setValue(`allKras[${index}].slA_Reminder`, data.slaReminderCount || 0);
  //       formMethods.setValue(`allKras[${index}].weight`, data.weight || 0);

  //       // 360° Appraisal fields
  //       formMethods.setValue(`allKras[${index}].is360Applicable`, data.is360Applicable || false);
  //       formMethods.setValue(
  //         `allKras[${index}].includePeerReview`,
  //         data.includePeerReview || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${index}].peerReviewAffectsScore`,
  //         data.peerReviewAffectsScore || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${index}].includeUpwardReview`,
  //         data.includeUpwardReview || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${index}].upwardReviewAffectsScore`,
  //         data.upwardReviewAffectsScore || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${index}].includeCrossReview`,
  //         data.includeCrossReview || false
  //       );
  //       formMethods.setValue(`allKras[${index}].crossReviewType`, data.crossReviewType || 0);
  //       formMethods.setValue(
  //         `allKras[${index}].crossReviewAffectsScore`,
  //         data.crossReviewAffectsScore || false
  //       );

  //       formMethods.trigger();
  //     }, 200);
  //   }
  // }, [populateKRA, formMethods, ratings?.data, keyResultArea?.result, index, isNew]);



  const submit = async (datas) => {
    let payloads = []
    datas.allKras?.filter(kra => {  
      return  Object.values(kra).some(
    value => Boolean(value) === true 
  )
    })
      .forEach(data => {
        let processedTargetValue = data.targetValue;
        if (parseInt(data.measurementType) === 5) {
          processedTargetValue = 1;
        } else if (data.targetValue !== "yesNo") {
          processedTargetValue = parseInt(data.targetValue) || 0;
        }

        const payload = {
          objectiveId: parseInt(data.objectiveId),
          title: data.title,
          description: data.description,
          isFloatable: data.isFloatable,
          threshold: parseInt(data.threshold),
          // isAutoGenerated: data.isAutoGenerated,
          autoGeneratedSource: data.autoGeneratedSource,
          targetValue: processedTargetValue,
          measurementType: parseInt(data.measurementType),
          jobResponsibilitiesId: parseInt(data.jobResponsibilitiesId),
          currencyType: data.currencyType || "",
          rateId: parseInt(data.rateId) || 0,
          appraisalPeriod: parseInt(data.appraisalPeriod),
          periodStartDate: data.periodStartDate,
          // periodEndDate: data.periodEndDate,
          slaStartDuration: parseInt(data.slA_StartDuration),
          slaReviewDuration: parseInt(data.slA_ReviewDuration),
          slaReminderCount: parseInt(data.slA_Reminder),
          is360Applicable: data.is360Applicable,
          weight: parseInt(data.weight),
          jobRoleId: parseInt(data.jobRoleId),
        };

        if (data.is360Applicable) {
          Object.assign(payload, {
            includePeerReview: data.includePeerReview,
            peerReviewAffectsScore: data.peerReviewAffectsScore,
            includeUpwardReview: data.includeUpwardReview,
            upwardReviewAffectsScore: data.upwardReviewAffectsScore,
            includeCrossReview: data.includeCrossReview,
            crossReviewType: parseInt(data.crossReviewType),
            crossReviewAffectsScore: data.crossReviewAffectsScore,
          });
        }
        payloads.push(payload)
      })
    console.log('paylods', payloads)
    try {
      const response = await onCreate({ krAs: payloads }).unwrap();
      if (response?.successful) {
        setIsOpen(false);
        onValidate();
        toast.success(response?.statusMessage, { style: { zIndex: 9999 } });
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage, { style: { zIndex: 9999 } });
    }
  };
  const userPerm = JSON.parse(localStorage.getItem("x-u-perm")) || [];
  const userDepartmentId = JSON.parse(localStorage.getItem("user"))?.departmentId
  const perm = [DEFINED_PERMISSIONS.SeniorHRManager,
  DEFINED_PERMISSIONS.PrimaryHRManager, DEFINED_PERMISSIONS.HRManager
  ]
  const hasAllDepartmentPermission = perm.some(user => userPerm.includes(user));
  const [allKras, setAllKras] = useState([{ id: Date.now() }])
  const [showIndex, setShowIndex] = useState(0)
  const handleAddKra = () => {

    setAllKras(prev => [...prev, { id: Date.now() }]);
    setShowIndex(prev => prev + 1)
    setIsNew(true);
  };
  const handleRemoveKra = (index) => {
    setIsNew(false)
    // 1. Get fresh values
    const fresh = getValues("allKras") || [];

    // 2. Remove item
    const updated = fresh.filter((_, i) => i !== index);
    console.log('updated', updated)
    setValue("allKras", updated);

    setAllKras(updated);
    setShowIndex((prev) => (prev > 0 ? prev - 1 : 0));
    setIndex((prev) => Math.max(prev - 1, 0));
    trigger('allKras')
  };

  const watchAttachKRA = useWatch({ control, name: `allKras[${index}].attachKRA` });

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up</h4>
          <h1 className="text-[28px] font-[800]">key Result Area</h1>
          <p>
            Define measurable outcomes for your selected objectives by creating
            structured KRAs (Key Result Areas)
          </p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div className="flex justify-between items-center mb-6 col-span-2">
          <p className="text-black">{showIndex + 1} of {allKras?.length}</p>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              disabled={showIndex <= 0}
              className="bg-white rounded-md text-[var(--primary-color)] px-4 py-2"
              onClick={() => { setShowIndex(prev => Math.max(prev - 1, 0)); setIsNew(false) }}
            >
              Prev
            </button>

            <button disabled={showIndex >= allKras?.length - 1}
              type="button"
              className="bg-[var(--primary-color)] text-white px-4 py-2 rounded-md"
              onClick={() => { setShowIndex(prev => prev + 1); setIsNew(false) }}
            >
              Next
            </button>

          </div> </div>
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              {allKras?.map((dat, index) =>
                <section onClick={() => setIndex(index)} key={index}
                  className={`${showIndex === index ? "block" : "hidden pointer-events-none"}`}
                >
                  <div className="flex items-center justify-between mb-4">


                    <div className="w-10" />

                    <CheckBox name={`Attach non-core KRA`} camelCase={`allKras[${index}].attachKRA`} isRequired={false} />

                  </div>
                  <div>
                    <FormInput
                      title={"Title"}
                      camelCase={`allKras[${index}].title`}
                      placeholder={"select"}
                    />
                    {watchAttachKRA && (
                      <FormSelect
                        title={"Key Result Area"}
                        camelCase={`allKras[${index}].KRA`}
                        placeholder={"select"}
                        array={keyResultArea?.result?.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt?.title}
                          </option>
                        ))}
                        defaultValue={"Select KRA"} defaultId={0}
                      />
                    )}
                  </div>
                  <div className="grid gap-5 grid-cols-2">
                    <FormSelect
                      title={"Department"}
                      camelCase={`allKras[${index}].departmentId`}
                      placeholder={"select"}
                      array={
                        (hasAllDepartmentPermission ? departments?.responseObject?.pageItems :
                          [departments?.responseObject?.pageItems?.find(dat => dat?.id === userDepartmentId)])?.map((opt) => (
                            <option key={opt?.id} value={opt?.id}>
                              {opt?.name}
                            </option>
                          ))}
                      defaultValue={"Select Department"}
                    />
                    <FormSelect
                      title={"Objective"}
                      camelCase={`allKras[${index}].objectiveId`}
                      placeholder={"select"}
                      array={
                        (!hasAllDepartmentPermission ?
                          objectives?.result?.filter(dat => (dat?.objectiveType?.toLowerCase() === "operational")) :
                          objectives?.result)?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt?.title} {opt?.designation?.designationName}
                            </option>
                          ))}
                      defaultValue={"Select Objective"}
                    />
                    <FormSelect
                      title={"Job Role"}
                      camelCase={`allKras[${index}].jobRoleId`}
                      placeholder={"select"}
                      array={jobRole?.responseObject?.pageItems?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt?.designationName}
                        </option>
                      ))}
                      defaultValue={"Select Job Role"}
                    />
                    {
                      jobRoleId && <FormSelect
                        title={"Job Title"}
                        camelCase={`allKras[${index}].jobResponsibilitiesId`}
                        placeholder={"select"}
                        array={jobTitles?.data?.responseObject?.pageItems?.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt?.title}
                          </option>
                        ))}
                        defaultValue={"Select Job Designation"}
                      />
                    }
                    <FormInput
                      title={"Period Start Date"}
                      camelCase={`allKras[${index}].periodStartDate`}
                      placeholder={"select"}
                      type={"date"}
                    />
                    <FormSelect
                      title={"Appraisal Period"}
                      camelCase={`allKras[${index}].appraisalPeriod`}
                      placeholder={"select"}
                      array={appraisalPeriod.map((opt) => (
                        <option key={opt.filter} value={opt.filter}>
                          {opt?.name}
                        </option>
                      ))}
                      defaultValue={"Select Appraisal Period"}
                    />
                    <FormSelect
                      title={"Measurement Type"}
                      camelCase={`allKras[${index}].measurementType`}
                      placeholder={"select"}
                      array={MeasurementType.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.name}
                        </option>
                      ))}
                      defaultValue={0}
                    />
                    {parseInt(watchMeasurementType) === 2 && (
                      <FormSelect
                        title={"Currency Type"}
                        camelCase={`allKras[${index}].currencyType`}
                        placeholder={"select"}
                        array={[
                          <option key="empty" value="">
                            Select Currency
                          </option>,
                          ...currencies.map((opt) => (
                            <option key={opt.name} value={opt.name}>
                              {opt.name}
                            </option>
                          )),
                        ]}
                        defaultValue={""}
                      />
                    )}

                    {parseInt(watchMeasurementType) === 4 && (
                      <FormSelect
                        title={"Rating"}
                        camelCase={`allKras[${index}].rateId`}
                        placeholder={"select"}
                        array={[
                          <option key="empty" value={0}>
                            Select Rating
                          </option>,
                          ...(ratings?.data?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.title}
                            </option>
                          )) || []),
                        ]}
                        defaultValue={0}
                      />
                    )}

                    {parseInt(watchMeasurementType) === 5 && (
                      <FormInput
                        title={"Yes/No Target Value"}
                        camelCase={`allKras[${index}].targetValue`}
                        placeholder={"Yes/No"}
                        type={"text"}
                        disabled={true}
                        value="1"
                        defaultValue="1"
                      />
                    )}

                    {(parseInt(watchMeasurementType) === 1 ||
                      parseInt(watchMeasurementType) === 3) && (
                        <FormInput
                          title={"Target Value"}
                          camelCase={`allKras[${index}].targetValue`}
                          placeholder={"Enter value"}
                          type={"number"}
                          max={parseInt(watchMeasurementType) === 3 ? 100 : undefined}
                        />
                      )}
                    {/* Show threshold for Currency (editable) */}
                    {parseInt(watchMeasurementType) === 2 && (
                      <FormInput
                        title={"Target Value"}
                        camelCase={`allKras[${index}].targetValue`}
                        placeholder={"Enter threshold value"}
                        type={"number"}
                      />
                    )}

                    {/* Show threshold for Rating (auto-populated from highest scale) */}
                    {parseInt(watchMeasurementType) === 4 &&
                      watchRateId &&
                      parseInt(watchRateId) > 0 && (
                        <FormInput
                          title={"Target Value"}
                          camelCase={`allKras[${index}].targetValue`}
                          placeholder={"Auto-populated from rating scale"}
                          type={"number"}
                          disabled={true}
                        />
                      )}
                    <FormInput
                      title={"Threshold"}
                      camelCase={`allKras[${index}].threshold`}
                      placeholder={"Enter threshold value"}
                      type={"number"}
                    />
                    <FormInput
                      title={"SLA Start Duration"}
                      camelCase={`allKras[${index}].slA_StartDuration`}
                      placeholder={"select"}
                      type={"number"}
                    />
                    <FormInput
                      title={"SLA Review Duration"}
                      camelCase={`allKras[${index}].slA_ReviewDuration`}
                      placeholder={"select"}
                      type={"number"}
                    />
                    <FormInput
                      title={"SLA Reminder"}
                      camelCase={`allKras[${index}].slA_Reminder`}
                      placeholder={"select"}
                      type={"number"}
                    />


                    <FormInput
                      title={"Weight"}
                      camelCase={`allKras[${index}].weight`}
                      placeholder={"select"}
                      type={"number"}
                    />
                  </div>

                  {/* Basic Options */}
                  <div className="grid gap-3 grid-cols-3 mb-4">
                    <div className="flex items-center gap-2">
                      <CheckBox isRequired={false} camelCase={`allKras[${index}].isFloatable`} />
                      <small>Is Floatable</small>
                    </div>
                  </div>

                  {/* 360° Appraisal Section */}
                  <div className="mb-4">
                    <div className="flex items-center gap-2 mb-3">
                      <CheckBox isRequired={false} camelCase={`allKras[${index}].is360Applicable`} />
                      <small className="font-semibold">Apply 360° Appraisal?</small>
                      <HiQuestionMarkCircle
                        className="text-gray-500 cursor-help"
                        size={16}
                        title="Enable comprehensive feedback from multiple perspectives including peers, subordinates, and cross-functional teams"
                      />
                    </div>

                    {/* 360° Appraisal Options */}
                    <div className="ml-6 border-l-2 border-gray-200 pl-4 space-y-3">
                      {/* Peer Review Section */}
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <CheckBox isRequired={false}
                            camelCase={`allKras[${index}].includePeerReview`}
                            disabled={!is360Applicable}
                          />
                          <small>Peer Review</small>
                          <HiQuestionMarkCircle
                            className="text-gray-500 cursor-help"
                            size={14}
                            title="Feedback from colleagues at the same level"
                          />
                        </div>
                        <div className="ml-6">
                          <div className="flex items-center gap-2">
                            <CheckBox isRequired={false}
                              camelCase={`allKras[${index}].peerReviewAffectsScore`}
                              disabled={!is360Applicable}
                            />
                            <small>Affects Overall Score?</small>
                          </div>
                        </div>
                      </div>

                      {/* Upward Review Section */}
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <CheckBox isRequired={false}
                            camelCase={`allKras[${index}].includeUpwardReview`}
                            disabled={!is360Applicable}
                          />
                          <small>Upward Review</small>
                          <HiQuestionMarkCircle
                            className="text-gray-500 cursor-help"
                            size={14}
                            title="Feedback from subordinates – commonly for leadership KRAs"
                          />
                        </div>
                        <div className="ml-6">
                          <div className="flex items-center gap-2">
                            <CheckBox isRequired={false}
                              camelCase={`allKras[${index}].upwardReviewAffectsScore`}
                              disabled={!is360Applicable}
                            />
                            <small>Affects Overall Score?</small>
                          </div>
                        </div>
                      </div>

                      {/* Cross Review Section */}
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <CheckBox isRequired={false}
                            camelCase={`allKras[${index}].includeCrossReview`}
                            disabled={!is360Applicable}
                          />
                          <small>Cross Review</small>
                          <HiQuestionMarkCircle
                            className="text-gray-500 cursor-help"
                            size={14}
                            title="Review from other units or departments"
                          />
                        </div>
                        <div className="ml-6 space-y-2">
                          <div className="grid gap-3 grid-cols-1">
                            <FormSelect isRequired={false}
                              title={"Specify Type"}
                              camelCase={`allKras[${index}].crossReviewType`}
                              placeholder={"select"}
                              disabled={!is360Applicable}
                              array={crossReviewType.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                  {opt.name}
                                </option>
                              ))}
                              isOptional={true}
                            />
                          </div>
                          <div className="flex items-center gap-2">
                            <CheckBox isRequired={false}
                              camelCase={`allKras[${index}].crossReviewAffectsScore`}
                              disabled={!is360Applicable}
                            />
                            <small>Affects Overall Score?</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <FormTextArea
                    className="h-[200px]"
                    title={"Description"}
                    camelCase={`allKras[${index}].description`}
                  />
                  <div className="flex justify-end gap-4 mt-6">
                    {allKras?.length > 1 &&
                      <button onClick={() => handleRemoveKra(index)}
                        type="button"
                        className=" bg-red-50 text-red-900
                   px-5 py-2 rounded-sm flex items-center space-x-2"
                      >
                        <FaMinus />

                        <span>Remove  KRA</span>
                      </button>
                    }
                    <button onClick={handleAddKra}
                      type="button"
                      className="bg-[#18BB0C1A] text-[#18BB0C]
                  px-5 py-2 rounded-sm flex items-center space-x-2"
                    >
                      <FaPlus />

                      <span>Add  KRA</span>
                    </button>
                  </div>


                </section>)}
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={false}
                  // disabled={!isValid}

                  width={"auto"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  {isLoading ? "Creating..." : "Create"}
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};
